export default __webpack_public_path__ + "static/media/people3.6c6ce936.svg";